import { Module } from 'vuex'
import { RootState } from '@/store/store-types'
import { useGlossaryDefinitionHttp } from '@/core/api/glossary-definitions'
import { GlossaryDefinition, GlossaryDefinitionPayload } from '@/core/models/glossary-definition'

const state: GlossaryDefinition = new GlossaryDefinition(<GlossaryDefinitionPayload>{})

export const glossaryDefinition: Module<GlossaryDefinition, RootState> = {
    namespaced: true,
    state,
    mutations: {
        update: (state: GlossaryDefinition, payload: GlossaryDefinitionPayload) => {
            state.fill(payload)
        }
    },
    actions: {
        getOrNew: <T>(context: any, payload: { id: number | undefined, payload: any }): Promise<T> => {
            state.unset()
            if (payload.id) {
                return context.dispatch('get', payload)
            } else {
                return new Promise<T>((resolve) => {
                    resolve({} as T)
                })
            }
        },
        get: <T>(context: any, payload: { id: number, payload: any }): Promise<T> => {
            state.unset()
            return new Promise<T>((resolve, reject) => {
                useGlossaryDefinitionHttp()
                    .find(payload.id, payload.payload)
                    .then((data: any) => {
                        context.commit('update', data.data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        },
        create: <T>(context: any, payload: { payload: any }): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useGlossaryDefinitionHttp()
                    .create(payload.payload)
                    .then((data: any) => {
                        context.commit('update', data.data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        },
        update: <T>(context: any, payload: { id: number, payload: any }): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useGlossaryDefinitionHttp()
                    .update(payload.id, payload.payload)
                    .then((data: any) => {
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        },
        updateOrCreate: <T>(context: any, payload: { payload: any }): Promise<T> => {
            return payload.payload.id ?
                context.dispatch('update', { id: payload.payload.id, payload: payload.payload }) :
                context.dispatch('create', { payload: payload.payload })
        },
        delete: <T>(context: any, payload: { id: number }): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useGlossaryDefinitionHttp()
                    .del(payload.id)
                    .then((data: any) => {
                        context.commit('update', new GlossaryDefinition(<GlossaryDefinitionPayload>{}))
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        },
    },
    getters: {
        get: (state: GlossaryDefinition): GlossaryDefinition => {
            return state
        }
    }
}